export default __webpack_public_path__ + "static/media/philosophies_of_prosperity.4ebf334f.png";